import React from "react";
import { IoCalendarOutline } from "react-icons/io5";
import { BiCalendarEvent } from "react-icons/bi";
import { RiAlarmLine } from "react-icons/ri";
import TaskStatus from "../../Enum/TaskStatus";

const remainderLabel = (value) => {
  if (value === "DAILY") return "Daily";
  if (value === "ONE_TIME") return "One Time";
  return "-";
};

const TaskInfo = ({ task }) => {
  const status = TaskStatus.find((list) => list.value === task?.status);

  return (
    <div className="flex flex-col gap-4 font-inter">
      <div className="flex mt-3 justify-start gap-3">
        <IoCalendarOutline className="text-2xl text-primary" />
        <div className="text-[20px] text-gray-600 font-inter">{task?.title || "Null"}</div>
      </div>

      <div className="flex flex-col gap-2 text-gray-600">
        <div>Responsible Person: {task?.assignee?.name || "-"}</div>
        <div>Created By: {task?.createdBy || "-"}</div>
        <div>Last Modified: {task?.lastModified || "-"}</div>
      </div>

      <div className="flex flex-wrap gap-5">
        <div className="bg-green-50 flex text-gray-600 items-center gap-2 text-xs border border-green-500 rounded-full px-2 py-1 w-fit">
          <BiCalendarEvent className="text-green-500 text-base" />
          <div>Task Date: {task?.taskDate}</div>
        </div>

        <div className="bg-violet-50 flex text-gray-600 items-center gap-2 text-xs border border-violet-500 rounded-full px-2 py-1 w-fit">
          <RiAlarmLine className="text-violet-500 text-base" />
          <div>Reminder: {remainderLabel(task?.remainder)}</div>
        </div>
      </div>

      <div className="text-gray-600">Task Status: {status?.label || "Not Available"}</div>

      <div className="text-gray-600">
        Task Initiated By: {task?.taskInitiatedByBoolean === true ? "Yes" : task?.taskInitiatedByBoolean === false ? "No" : "-"}
      </div>

      <div className="flex flex-col gap-2 text-gray-600">
        <div className="flex gap-1">
          <span className="shrink-0">Initial Task Information Medium:</span>
          <span
            title={task?.initialTaskInformationMedium}
            className="line-clamp-3 break-words overflow-hidden max-w-[260px]"
          >
            {task?.initialTaskInformationMedium || "-"}
          </span>
        </div>
        <div className="flex gap-1">
          <span className="shrink-0">Final Task Information Medium:</span>
          <span
            title={task?.finalTaskInformationMedium}
            className="line-clamp-3 break-words overflow-hidden max-w-[260px]"
          >
            {task?.finalTaskInformationMedium || "-"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TaskInfo;
